<template>
    <v-container fill-height justify-center>
        <v-card style="max-width: 320px; min-width: 300px">
            <v-toolbar flat class="primary darken" dark>
                <div class="headline">Logg inn</div>
            </v-toolbar>
            <v-card-text class="blue darken-3">
                <v-text-field solo v-model="user.username" placeholder="Brukernavn" :hide-details="!errors.username"
                              class="mb-3"
                              :error-messages="errors.username" @keypress.enter="login"/>
                <v-text-field solo v-model="user.password" type="password" placeholder="Passord"
                              :hide-details="!errors.password"
                              :error-messages="errors.password" @keypress.enter="login"/>

                <v-btn color="primary lighten-3" block large class="ma-0 mt-3 black--text" @click="login" :loading="loading">
                    Logg inn
                    <v-icon right>arrow_forward</v-icon>
                </v-btn>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                errors: {},
                user: {
                    username: '',
                    password: ''
                }
            }
        },

        methods: {
            login() {
                this.errors = {};
                this.loading = true;
                this.$http.post('auth/login/', this.user).then(response => {
                    let token = response.data.key;
                    this.$http.defaults.headers.common['Authorization'] = `Token ${token}`;
                    localStorage.setItem('token', token);
                    return this.$http.get('auth/user/').then(response => {
                        this.$router.replace({name: 'Report'});
                        this.$root.user = response.data;
                    });
                }).catch(error => {
                    this.errors = error.response.data;
                    this.$http.defaults.headers.common['Authorization'] = null;
                    localStorage.removeItem('token');
                }).finally(() => {
                    this.loading = false;
                })
            }
        }
    }
</script>